import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
  BUTTON_SIZE,
  Z_INDEXS,
} from '../../../themes'
import { colorThemeSelector } from '../../../helpers'

const keepButtonTextColor = ({ colorTheme }) => (
  typeof colorTheme === 'string'
    ? colorThemeSelector(colorTheme).FONT_COLOR.TEXT
    : COLOR.BLACK_6
)

export const StyleModal = styled.div`
  .div-Modal{
    background: #000000;
    display: block;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0.7;
    z-index: ${Z_INDEXS.LV_MAX};
  }

  .content-Modal{
    z-index: ${Z_INDEXS.LV_MAX};
    display: flex;
    position: fixed;
    background: #F9F6F2;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 480px;
    min-height: 244px;
    height: auto;
    text-align: center;
    border-radius: 0;
    box-shadow: 0px 8px 10px -6px #0000001A, 0px 20px 25px -5px #0000001A;
    -webkit-animation-name: example;
    -webkit-animation-duration: 0.5s;
    animation-name: example;
    animation-duration: 0.5s;
  }

  .sub-content {
    padding: 32px 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .head-modal{
    font-family: NunitoSansSemiBold, NunitoSans, sans-serif;
    font-size: 24px;
    font-weight: 600;
    color: ${COLOR.BLACK_6};
    letter-spacing: 0;
    margin-bottom: 24px;
  }

  .text-content {
    font-family: NunitoSansRegular, NunitoSans, sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: ${COLOR.BLACK_6};
    line-height: 1.5;
    white-space: pre-line;
    margin-bottom: 32px;
  }

  .description{
    font-family: NunitoSansRegular, NunitoSans, sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: ${COLOR.BLACK_6};
    margin-bottom: 32px;
  }

  .btn-modal {
    bottom: 0;
    width: 100%;
    height: auto;
    padding: 0;
  }

  .tabel {
    display: table;
    border-collapse: collapse;
    width: 100%;
    background: transparent;
  }

  .table-row{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    padding: 0;
  }

  .table-cell, .table-cell-default{
    flex: 1;
    display: flex;
    justify-content: center;
  }

  .table-cell{
    line-height: normal;
  }

  .modal-btn-confirm, .modal-btn-keep{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 44px;
    font-size: 16px;
    font-family: NunitoSansSemiBold, NunitoSans, sans-serif;
    font-weight: 600;
    color: ${COLOR.BLACK_6};
    border-radius: 8px;
    cursor: pointer;
    float: none;
    transition: opacity 0.2s ease;
  }

  .modal-btn-confirm, .modal-btn-confirm:hover {
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    background: transparent;
    color: ${COLOR.BLACK_6};
    margin-left: 0;
  }

  .modal-btn-keep, .modal-btn-keep:hover {
    border: none;
    background: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    color: ${keepButtonTextColor};
  }

  .modal-btn-confirm:hover, .modal-btn-keep:hover {
    opacity: 0.85;
  }

  .text-error{
    margin-top: 10px;
    font-size: ${FONT_SIZE.TN};
    color: ${COLOR.GOLD_1};
  }

  .text-data{
    margin-top: 50px;
    border-bottom: 1px solid ${COLOR.BLACK_1};
    font-size: ${FONT_SIZE.XS};
    color: ${COLOR.BLACK_1};
  }

  .input-delete{
    margin-top: 50px;
    border: none;
    width: 100%;
    outline: none;
    border-bottom: 1px solid ${COLOR.BLACK_1};
    font-size: ${FONT_SIZE.XS};
    padding-bottom: 6px;
    ::placeholder {
      font-size: ${FONT_SIZE.XS};
      color: ${COLOR.GRAY_3}
    }
  }
`

